import React from 'react';
import { TailProps } from './Page.types';

const Tail = ({ children, minimized }: TailProps) =>
  React.cloneElement(children, { minimized });

Tail.displayName = 'Page.Tail';

export default Tail;
